var map = {
	"./de/returnBtn.png": "CGIO",
	"./en/returnBtn.png": "i4+M",
	"./es/returnBtn.png": "YTnM",
	"./fr/returnBtn.png": "Tb2x",
	"./ja/returnBtn.png": "7CrP",
	"./ko/returnBtn.png": "yJwK",
	"./pt/returnBtn.png": "wr+g",
	"./ru/returnBtn.png": "2ivi",
	"./tc/returnBtn.png": "SRAv",
	"./th/returnBtn.png": "lFad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Chz4";